export default __webpack_public_path__ + "static/media/dumbbells.37bd5f76.svg";